export default {
  roleList: [],
  roleMenuList: [],
  roleAddPopup: false,
  roleInfo: {},
  menuAddPopup: false,
  roleId: '',
  selectedData: [],
  userRole: [],
};
